import type React from 'react';

import type { Dayjs } from '@/js/libs/dayjs';

import { DATE_TIME_FORMAT } from 'src/constants.tsx';

export interface IDateTime {
  value?: Dayjs | null;
  showLocal?: boolean;
  dateFormat?: string;
}

const DateTime: React.FC<IDateTime> = ({ value, dateFormat = DATE_TIME_FORMAT, showLocal = false }) => (
  <span>{showLocal ? value?.local().format(dateFormat) : value?.format(dateFormat)}</span>
);

export default DateTime;
